export default function generateKey() {
    try {
        return [...crypto.getRandomValues(new Uint8Array(16))].map(m => `0${m.toString(16)}`.slice(-2)).join('')
    }
    catch (e) {}
    try {
        return (crypto as any).randomBytes(16).toString("hex")
    }
    catch (e) {}
    return [...Array(32)].map(() => Math.floor(Math.random() * 16).toString(16)).join('')
}